<div class="radio-button-list">
	@for (option of options(); track option.value) {
		<div
			class="radio-option-item"
			[class.selected]="selectedValue() === option.value"
			[class.no-subtitle]="!option.subtitle"
			(click)="selectOption(option.value)"
		>
			<div class="radio-option-content">
				<div class="radio-option-title-row">
					<div class="radio-option-title">{{ option.title | propertitlecase }}</div>
					@if (option.label) {
						<div class="radio-option-label">{{ option.label | currency }}</div>
					}
				</div>
				@if (option.subtitle) {
					<div class="radio-option-subtitle">{{ option.subtitle }}</div>
				}
			</div>
			<div class="radio-option-button">
				<sp-radio-button [noInteraction]="true" [selected]="selectedValue() === option.value"></sp-radio-button>
			</div>
		</div>
	}
</div>
